(function () {
  const elementsWrapper = [...document.querySelectorAll('.js-handler-items')];
  
  if (!elementsWrapper.length) {
    return;
  }
  
  const elements = elementsWrapper.reduce((elements, wrapper) => elements.concat(...wrapper.querySelectorAll('.js-handler-item')), []);
  
  if (!elements.length) {
    return;
  }
  
  class SectionsManager {
    get mainWrapper() {
      return elementsWrapper[0];
    }
    
    groupItemsByPostCode() {
      if (!this.areaGroups) {
        this.initAreaGroups();
      }
      
      for (const areaGroupCode in this.areaGroups) {
        const elements = this.areaGroups[areaGroupCode];
        const section = this.createSectionWrapper(areaGroupCode);
        const sectionItems = section.querySelector('.js-sub-section-items');
        elements.forEach((element) => sectionItems.appendChild(element));
        this.mainWrapper.appendChild(section);
      }
      
      this.mainWrapper.classList.add('no-grid');
    }
    
    createSectionWrapper(areaGroupCode) {
      const section = document.createElement('section');
      section.classList.add('handlers__sub-section');
      section.classList.add('js-sub-section');
      section.innerHTML = `
    <h3 class="handlers__sub-section-title">${theme.strings.handlers.zipCodeArea} ${areaGroupCode}</h3>
    <div class="handlers__sub-section-items js-sub-section-items"></div>
    `;
      return section;
    }
    
    initAreaGroups() {
      const areaGroups = {};
      
      for (const element of elements) {
        const title = element.querySelector('.js-title')?.textContent.trim() || '';
        const country = element.dataset.country?.trim() || '';
        const postCodeFirstDigit = parseInt(element.querySelector('.js-postcode')?.textContent[0] || 0);
        
        let areaGroupKey = country === 'germany'
          ? postCodeFirstDigit
          : theme.strings.handlers.countries[country];
        
        if (!title) {
          continue;
        }
        
        if (!areaGroups[areaGroupKey]) {
          areaGroups[areaGroupKey] = [];
        }
        areaGroups[areaGroupKey].push(element);
      }
      
      this.areaGroups = areaGroups;
    }
    
    removeEmptySections() {
      elementsWrapper.slice(1).forEach(wrapper => wrapper.remove());
    }
  }
  
  class ComponentHandlers {
    constructor() {
      this.sectionsManager = new SectionsManager();
    }
    
    init() {
      this.sectionsManager.groupItemsByPostCode();
      this.sectionsManager.removeEmptySections();
    }
  }
  
  const componentHandlers = new ComponentHandlers();
  componentHandlers.init();
})();